import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createContactView,
  deleteContactView,
  listContactViews,
  updateContactView,
  type ContactViewInput,
} from '@/api/contactViews'

export function useContactViews() {
  return useQuery({ queryKey: ['contact-views'], queryFn: listContactViews })
}

export function useCreateContactView() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: ContactViewInput) => createContactView(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contact-views'] }),
  })
}

export function useUpdateContactView() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: ContactViewInput }) => updateContactView(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contact-views'] }),
  })
}

export function useDeleteContactView() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteContactView(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contact-views'] }),
  })
}
